import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Pause from "../common/Pause";
import { getMediaDetails } from "../utils";

const MediaPaused = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, updatedBy, updatedAt } = getMediaDetails(log);
  return <Pause name={name} updatedAt={updatedAt} updatedBy={updatedBy} />;
};

export default MediaPaused;
